<template>
  <div class="results">
    <p class="hint intro">Recopiez les chiffres de LinkedIn (statistiques du post). Laissez vide un chiffre que vous ne connaissez pas : il n'est pas compté comme zéro.</p>
    <div class="metrics">
      <div v-for="metric in metrics" :key="metric.key" class="metric">
        <CustomTextField :content=metricInputs[metric.key] />
        <p v-if="metric.help" class="hint">{{ metric.help }}</p>
      </div>
    </div>
    <p class="summary-line">
      <span v-if="engagement !== undefined">Taux d'engagement : <strong>{{ engagement }}</strong> <span class="muted">(réactions + commentaires + partages, par impression)</span></span>
      <span v-else class="muted">Le taux d'engagement s'affiche quand les impressions, réactions, commentaires et partages sont renseignés.</span>
    </p>
    <p v-if="publication.metrics && publication.metrics.updatedAt" class="hint">Dernière saisie le {{ formatDateTime(publication.metrics.updatedAt) }}.</p>
  </div>
</template>

<script>
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import {METRICS, formatDateTime} from "@/marketing/utils";

/**
 * Onglet Résultats (publication publiée) : les six chiffres relevés à la main. Ils sont enregistrés avec le bouton de la modale.
 */
export default {
  name: 'PublicationResults',
  props: ['publication', 'metricInputs'],
  components: {CustomTextField},
  data() {
    return {metrics: METRICS};
  },
  computed: {
    // Part des personnes ayant réagi, commentaire ou partagé ; sans l'un des quatre chiffres, on ne l'invente pas
    engagement() {
      const values = ['impressions', 'reactions', 'comments', 'shares'].map(key => this.metricInputs[key].value);
      if (values.some(value => value === '' || value === undefined || value === null || isNaN(Number(value)))) return undefined;
      const [impressions, reactions, comments, shares] = values.map(Number);
      if (impressions <= 0) return undefined;
      return `${((reactions + comments + shares) * 100 / impressions).toLocaleString('fr-FR', {maximumFractionDigits: 1})} %`;
    },
  },
  methods: {
    formatDateTime,
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
@require '~/src/marketing/style/modal.styl';

.intro
  margin-bottom 8px

.metrics
  display grid
  grid-template-columns repeat(3, minmax(0, 1fr))
  gap 4px 24px

.metric .hint
  margin 0 2px 6px
  min-height 2.4em
  font-size 0.8em

.summary-line
  margin 10px 2px 4px
  color THEME_COLOR_PRIMARY

.muted
  color CTRL_TEXT_MUTED
  font-size 0.9em

@media (max-width 760px)
  .metrics
    grid-template-columns 1fr 1fr
</style>
